export default __webpack_public_path__ + "static/media/3.21.39267ded.mp3";